export default __webpack_public_path__ + "static/media/for_yacht_charter.449cdd7b.webp";